import BulkSaleCard from '@/Components/BulkSale/Card'
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated'
import { Link, Head } from '@inertiajs/inertia-react';
import React from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Index = ({ store, ...props }) => {
    return (
        <Authenticated
            branchOffice={props.office}
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Ventas empresa</h2>}
        >
            <ToastContainer />
            <Head title={`Crear venta empresa - ${store === 'cerogrado' ? 'Cerogrado' : 'Trampoline Park'}`} />

            <div className="max-w-7xl px-4 py-4 mx-auto">
                <div className="flex justify-end items-center mb-4">
                    <Link href={route('bulk-sales.create')}>
                        <Button>Crear nueva venta empresa</Button>
                    </Link>
                </div>

                <div>
                    {props?.bulkSales.map((bulk_sale, index) => (
                        <BulkSaleCard {...bulk_sale} key={`${bulk_sale.rut}-${bulk_sale.id}-${index}`} />
                    ))}

                    {props?.bulkSales.length === 0 && (
                        <div className="flex justify-center items-center pt-8">
                            <h3 className="text-xl font-bold text-gray-500">Aún no hay ventas empresa</h3>
                        </div>
                    )}
                </div>
            </div>
        </Authenticated>
    )
}

export default Index